export class CheckTokenRequest {
	public token: string;

	constructor(_token: string) {
		this.token = _token;
	}
}

